<template>
  <div class="l-edit-dialog-box">
    <el-form :model="form_data" label-width="120px" ref="form" :rules="rules" label-position="left" v-loading="loading">
      <el-form-item label="资源名称" prop="name">
        <el-input v-model="form_data.name" autocomplete="off" placeholder="请输入资源名称"></el-input>
      </el-form-item>
      <el-form-item label="资源标识" prop="identify">
        <el-input v-model="form_data.identify" autocomplete="off" placeholder="请输入资源标识"></el-input>
      </el-form-item>
      <el-form-item label="资源类型" prop="type">
        <el-select v-model="form_data.type" placeholder="请选择资源类型">
          <el-option :label="item" :value="parseInt(index)" v-for="(item,index) in type_names" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="请求方法" prop="method" v-if="form_data.type==TYPES.api">
        <el-select v-model="form_data.method" placeholder="请选择请求方法">
          <el-option :label="item" :value="parseInt(index)" v-for="(item,index) in METHOD_NAMES" :key="index"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="状态" prop="state">
        <el-radio-group v-model="form_data.state">
          <el-radio :label="parseInt(index)" v-for="(item,index) in STATE_NAMES" :key="index">{{item}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否公共资源" prop="is_public">
        <el-radio-group v-model="form_data.is_public">
          <el-radio :label="parseInt(index)" v-for="(item,index) in IS_PUBLIC_NAMES" :key="index">{{item}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="使用场景" prop="use_type">
        <el-radio-group v-model="form_data.use_type">
          <el-radio :label="1" >PC后台权限</el-radio>
          <el-radio :label="2" >小程序权限</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
    </div>
  </div>

</template>

<script>
  import { TYPE_NAMES, TYPES, STATE_NAMES, IS_PUBLIC_NAMES, METHOD_NAMES } from '@/common/constants/resources';
  export default {
    name: 'l-resources-edit',
    props: {
      id: {
        type: [String, Number],
        default: null
      },
      visible: {
        type: Boolean,
      },
      useType: {
        type: [Number],
        default: 1
      }
    },

    components: {
    },
    computed: {
      hasId() {
        return this.$props.id !== null;
      }
    },
    watch: {
      visible: {
        immediate: true,
        handler(val) {
          if (val) {
            this.getData();
          }
        }
      }
    },
    data() {
      return {
        loading: false,//页面是否加载中

        //资源类型
        type_names: TYPE_NAMES,
        STATE_NAMES: STATE_NAMES,
        IS_PUBLIC_NAMES: IS_PUBLIC_NAMES,
        METHOD_NAMES: METHOD_NAMES,
        TYPES: TYPES,

        //是否显示

        //表单数据
        form_data: {
          name: '',
          identify: '',
          type: 1,
          method: '',
          state: 1,
          use_type: '',
          is_public: 0
        },
        //表单验证规则
        rules: {
          name: [
            { required: true, message: '资源名称不能为空', trigger: 'change' }
          ],
          identify: [
            { required: true, message: '资源标识不能为空', trigger: 'change' }
          ],
          type: [
            { type: 'number', required: true, message: '请选择资源类型', trigger: 'change' }
          ],
          //   method: [
          //     { type: 'number', required: true, message: '请选择请求方法', trigger: 'change' }
          //   ],
          state: [
            { type: 'number', required: true, message: '请选择状态', trigger: 'change' }
          ],
          is_public: [
            { type: 'number', required: true, message: '请选择公有/私有', trigger: 'change' }
          ],
           use_type: [
            { type: 'number', required: true, message: '请选择使用场景', trigger: 'change' }
          ],
        },
        //提交按钮是否显示加载中
        submitting: false,
      }
    },

    methods: {
      //点击取消通知父组件关闭对话框
      cancel() {
        this.$emit('update:visible', false);
      },

      //获取数据
      getData() {
        if (this.hasId) {
          this.loading = true;
          this.$_invoke(`resource_getEditData`, { id: this.$props.id }).then((ret) => {
            this.form_data = ret.data;
          }).finally(() => {
            this.loading = false;
          });

        } else {
          this.form_data.use_type = this.$props.useType
        }
      },

      //提交数据
      handleSubmit() {
        if (this.loading) return;
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitting = true;
            if (!this.hasId) {//添加
              this.$_invoke('resource_save', this.form_data).then(() => {
                this.$_msg.success('添加成功');
                this.$emit('on-success');
              }).finally(() => {
                this.submitting = false;
              })
            } else {//修改
              this.$_invoke(`resource_update`, {
                id: this.$props.id,
                ...this.form_data
              }).then(() => {
                this.$_msg.success('修改成功');
                this.$emit('on-success');
              }).finally(() => {
                this.submitting = false;
              })
            }
          }
        })

      },
    },
  }
</script>